import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    Button
} from 'reactstrap';
import { getFee, saveFee, getDivisions } from '../../API';
import AccountSelect from '../Account/AccountSelect';
import { validateString, store, getInputDate, blurCurrency, addMinutesToDateTime } from '../../Helper';

function FeeEdit(props) {
    const [fee, setFee] = useState(null);
    const [account, setAccount] = useState(null);
    const [isLoadingFee, setIsLoadingFee] = useState(true);
    const [isLoadingAccount, setIsLoadingAccount] = useState(true);
    const [divisions, setDivisions] = useState([]);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(true);
    const [accountSelectModal, setAccountSelectModal] = useState(false);

    useEffect(() => {
        fetchDivisions();
        fetchFee();
    }, []);

    const fetchDivisions = async () => {
        setIsLoadingDivisions(true);

        setDivisions(await getDivisions());

        setIsLoadingDivisions(false);
    }

    const fetchFee = async () => {
        setIsLoadingFee(true);

        const fetchedFee = await getFee(props.match.params.feeId);
        setFee(fetchedFee);

        setIsLoadingFee(false);
    }

    const updateFee = e => {
        let value = e.target.value;
        switch (e.target.type) {
            case "number":
                value = e.target.valueAsNumber;
                break;
            case "date":
                value = new Date(e.target.value + 'T23:59:59.999');
                break;
        }

        setFee({
            ...fee,
            [e.target.name]: value
        });
    }

    const toggleAccountSelectModal = () => setAccountSelectModal(!accountSelectModal);

    const selectAccount = (account) => {
        if (account != null) {
            setFee({
                ...fee,
                accountID: account.accountID,
                account: account
            });
        }
    }

    const cancel = () => {
        console.log('Canceling...');
        props.history.goBack();
    };

    const save = async () => {
        if (await saveFee(fee))
            props.history.goBack();
    };

    const accountCardOptions = {
        fields: {
            active: true,
            accountNumber: true,
            account: true,
            contact: false,
            address: false,
            email: false,
            balance: false
        },
        actions: {
            view: false,
            eidt: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: true,
            cancel: false
        }
    };

    let feeJSX = (<div>No Fee Found...</div>);
    if (isLoadingFee) {
        feeJSX = (<div>Loading...</div>);
    } else if (fee) {
        feeJSX = (
            <div className="item-editables">
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-city"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Account" name="account.name" value={fee.account.name} readOnly={true} onClick={toggleAccountSelectModal} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-users"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="select" name="divisionID" value={fee.divisionID} onChange={updateFee}>
                                    {divisions.map(d => (<option value={d.divisionID} key={d.divisionID}>{d.divisionName}</option>))}
                                </Input>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-industry"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Facility" name="facility" value={fee.facility} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-hashtag"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Permit Number" name="identifier" value={fee.identifier} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-file-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <textarea className="form-control" placeholder="Description" name="feeDescription" value={fee.feeDescription} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="far fa-calendar"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="number" step="1" placeholder="Fiscal Year" name="fiscalYear" value={fee.fiscalYear} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-dollar-sign"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="number" placeholder="Amount" name="feeAmount" value={fee.feeAmount} onChange={updateFee} onBlur={blurCurrency} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="far fa-calendar-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="date" placeholder="Due Date" name="dueDate" value={getInputDate(fee.dueDate)} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4, offset: 4 }} xl={{ span: 3, offset: 6 }}>
                        <Button className="btn-block btn-icon" color="danr-red" onClick={cancel}><i className="fas fa-ban"></i><span>Cancel</span></Button>
                    </Col>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                        <Button className="btn-block btn-icon" color="danr-green" onClick={save}><i className="fas fa-save"></i><span>Save</span></Button>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div>
            <Row className="title-row">
                <Col>
                    <h1>{account?.name} Fee</h1>
                </Col>
            </Row>
            <Row className="edit-row">
                <Col>
                    {feeJSX}
                </Col>
            </Row>
            <AccountSelect multiple={false} open={accountSelectModal} toggle={toggleAccountSelectModal} select={selectAccount} accountCardOptions={accountCardOptions}/>
        </div>
    );
}

export default FeeEdit;